import type { FaireProductEntity } from "../../entity_types/product";

export const p_t97gbcf7qk: FaireProductEntity = {
  token: "p_t97gbcf7qk",
  type: "product",
  name: "Arkansas Upside Down Vintage Trucker Hat",
  brandToken: "b_wfq3tnmz7w",
  brandName: "Made by Mariah",
  imageUrl:
    "https://cdn.faire.com/fastly/20a84c7d4bfe53fdbe83a7f3b653ae2039e937252c060cd477e23d1dc7ab5f87.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5379b3afb041a8a4ddf8ccc49b8b1fc63420efb2d2f39eeb4e6917abc835a98d.jpeg",
    "https://cdn.faire.com/fastly/14178ce0bf4249f1622663f1d6001bb91909010c0ed88041c079a1a71e718194.jpeg",
  ],
  priceDollars: 17.5,
  description: "Red/Natural vintage trucker hat with Red embroidered design!",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:00.779Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
